import request from '@/common/request'

export default {
    // 审批
    queryTaskManage: params => {
        return request({
            url: '/v1/taskManage',
            method: 'get',
            params
        })
    },
    // 子任务查询方法
    querySubTask: params => {
        return request({
            url: '/v1/taskManage/subTask',
            method: 'get',
            params
        })
    },
    // 子任务启用状态
    updateEnable: (dynaSeg, data) => {
        return request({
            url: `/v1/taskManage/subTask/enable/${dynaSeg.id}`,
            method: 'patch',
            data
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/modules/flowable.js